// extracted by mini-css-extract-plugin
export default {"JobworkDetailsPage":"JobworkDetailsPage_JobworkDetailsPage__Wna6a"};